<!--
    Name:			Order.vue
    Description:	Show the order as a timeline block
    Remarks:		Position is managed by parent vue through the styleProp property
-->

<template>

    <div class="timelineWrap" :class="accentClass">
        <!--In order to move the order line, this div is positioned relative-->
        <div class="line" :style="styleProp">
            <div class="time-block accent-background-light accent-background-light-border" :style="{left: startX + '%', width: orderWidth + '%'}" v-on:click="showOrderInAlert('')">
                <div class="product-wrp-left">
                    <div class="product-wrp accent-background">
                        <div :key="product.id" v-for="product in products">
                            <div class="menu-holder" v-if="product.isDishGroupholder">
                                <div class="product-name mnu">{{product.quantity}} {{product.name}}	</div>
                                <div class="product-name mnu-child" :key="child.id" v-for="child in getChildren(product)">
                                    {{child.quantity}} {{child.name}} <span :key="prep.id" v-for="prep in child.children">  + {{prep.quantity > 1 ? prep.quantity + ' ' : ''}} {{prep.name}}</span>
                                </div>
                            </div>
                            <div class="product-name" v-else>
                                {{product.quantity}} {{product.name}} <span :key="prep.id" v-for="prep in product.children">  + {{prep.quantity > 1 ? prep.quantity + ' ' : ''}} {{prep.name}}</span>
                            </div>
                        </div>                       
                    </div>
                </div>
                <div class="product-wrp-right">
                    <div class="product-mnu-wrp" :key="product.id" v-for="product in products">
                        <div class="product-mnu-wrp" v-if="product.isDishGroupholder">
                            <div class="product-timeblock mnu-name" style="width:100%"></div>
                            <div class="product-timeblock" :style="{width : getProductWith(child) + '%', left: getProductLeft(child) + '%'}" :key="child.id" v-for="child in getChildren(product)"></div>
                        </div>
                        <div v-else class="product-timeblock" :style="{width : getProductWith(product) + '%', left: getProductLeft(product) + '%'}"></div>
                    </div>
                </div>
                <div class="order-remark">
                    <div class="order-remark-wrp accent-background"  v-for="remark in remarks">
                        {{remark.remark}}
                    </div>
                </div>
            </div>
        </div>

        <!--Gutter and buttens are positioned relative, to stay in the viewport-->
        <div class="gutter" v-on:click="showOrderInAlert('')">
            <span class="ordernr">{{Order.orderNr}}</span>
            <span class="order-prop ordername">{{Order.name}}</span>
            <!--<div class="order-prop">{{planning}}</div>-->
            <span class="order-prop"><translate item="OrderDetail.OrderStatus.Created" />: {{Order.createDate | formatTime}}</span>
            <span class="order-prop"><translate item="OrderDetail.OrderStatus.Start" />: {{Order.startDate | formatTime}}</span>
            <span class="order-prop"><translate item="OrderDetail.OrderStatus.Ready" />: {{Order.calculatedReadyDate | formatTime}}</span>
            <span class="order-prop"><translate item="OrderDetail.OrderStatus.TableNumber" />: {{Order.tableNumber}}</span>
            <span v-if="Order.desiredReadyDate != null" class="order-prop"><translate item="OrderDetail.OrderStatus.RequestedReadyTime" />: {{Order.desiredReadyDate | formatTime}}</span>
            <span class="order-prop scroll-to" v-on:click.stop="scrollto"></span>
        </div>
        <!--<div class="buttons large">
            <div class="btn preparing" v-on:click="preparingClick" :class="{'active' : Order.status == 1}">
                Wordt bereid
            </div>
            <div class="btn prepared" v-on:click="preparedClick" :class="{'active' : Order.status == 3}">
                Gereed
            </div>
            <div class="btn pause" :class="{'active' : Order.status == 0}">
                Gepland
            </div>
        </div>-->

    </div>
</template>

<script>

  
    import timeStore from '../repositories/TimeManager';
    import { ShowOn } from '../repositories/Constants';
    //import 'font-awesome/scss/font-awesome.scss';
    import orderDetail from '../components/OrderDetail';
    import Vue from 'vue';
    import translate from '../components/translate'

    // Import the EventBus
    import { EventBus } from '../repositories/Eventbus';


    const Order = {

        props: {
            //	StartDate: {
            //		type: Date
            //	},
            //	EndDate: { type: Date },
            Order: { type: Object },
            AccentColor: { type: Number },
            styleProp: { type: Object }
        },

        components: { translate },

        data: function () {
            return {
                //createX: 0,
                startX: 0,
                endX: 0
            };
        },


        methods: {
            preparingClick: function () {
                this.$signalR.setOrderStatus(this.Order, 1);
            },

            preparedClick: function () {
                this.$signalR.setOrderStatus(this.Order, 3);
            },

            pauseClick: function () {
                this.$signalR.setOrderStatus(this.Order, 2);
            },

            showOrderInAlert: function (message) {

                // create orderDetail vue compnent
                // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
                var ComponentClass = Vue.extend(orderDetail)
                // set properties
                var _orderDetail = new ComponentClass({
                    propsData: { Order: this.Order, Message: message }
                });
                _orderDetail.$mount();

                // https://sweetalert2.github.io/#configuration
                this.$fire({
                    //title: "Bestelling #" + this.Order.orderNr,
                    html: '', // _orderDetail.$el.outerHTML,
                    width: '40rem',
                    padding: '0px',
                    showConfirmButton: false,
                    customClass: {
                        container: 'order-detail'
                    },
                    onOpen: function (ell) {
                        ell.children[1].appendChild(_orderDetail.$el);
                    }
                }).then(() => {
                    _orderDetail.$destroy();
                });

            },

            /**
             * Gets the width of the product in percentages of the whole order
             * @param product
             */
            getProductWith: function (product) {

                // is the product devided into multiple batches?
                if (product.batches && product.batches.length > 0) {
                    
                    var starttime = this.getProductStartTime(product).getTime();
                    //new Date(product.batches.reduce(function (batchA, batchB) {
                    //    // problem: the batch start/endtime does not always match the product start/endtime. the product does not contain a starttime.
                    //    // becouse the products are always alligned to the right, we can calculate the starttime of the product.
                    //    return batchA.startTime < batchB.startTime ? batchA : batchB;
                    //}).startTime);
                    var latestBatch = product.batches.reduce(function (a, b) { return a.endTime > b.endTime ? a : b; });

                    var endtime = latestBatch.endTime.getTime();
                    var span = (endtime - starttime) - (latestBatch.paddingRight * 1000);
                    return ((span / 10) / this.Order.totalTime).toFixed(4)
                }

                return ((product.cookingTime / this.Order.totalTime) * 100).toFixed(4);
            },

            //getProductRight: function (product) {
            //    // the order can be devided over multiple batches, this product may be the first.
            //    if (product.batches && product.batches.length && this.Order.batches && this.Order.batches.length > 0) {

            //        var latestBatch = product.batches.reduce(function (a, b) { return a.endTime > b.endTime ? a : b; });

            //        var endtime = latestBatch.endTime;
            //        var span = ((this.Order.calculatedCarierReturnDate || this.Order.calculatedReadyDate ) - endtime) - (latestBatch.paddingRight * 1000);

            //        return ((span / 10) / this.Order.totalTime).toFixed(4)
            //    }

            //    return 0;
            //},

            getProductLeft: function (product) {

                // the order can be devided over multiple batches, this product may be the first.
                if (product.batches && product.batches.length && this.Order.batches && this.Order.batches.length > 0) {

                    var firstBatch = product.batches.reduce(function (a, b) { return a.startTime < b.startTime ? a : b; })
                    var starttime = firstBatch.startTime.getTime();

                    var span = (starttime - this.Order.startDate.getTime()) + (firstBatch.paddingLeft * 1000);

                    return ((span / 10) / this.Order.totalTime).toFixed(4)
                }

                return 0;
            },

            getProductStartTime: function (product) {            
                if (product.batches && product.batches.length > 0) {                    
                    return product.batches.reduce(function (a, b) { return a.startTime < b.startTime ? a : b; }).startTime;
                }
                return 1;                              
            },

            /**
             * Method scrolls the timline to the position of this order.
             * */
            scrollto: function () {
                EventBus.$emit('scroll-x-to', this.Order);
            },

            getChildren : function(menu) { 
                return menu.children.slice().sort((a, b) => {
                    return this.getProductStartTime(a) - this.getProductStartTime(b);
                });
            }
        },

        computed: {
            /**
             * Returns the remarks filterd by there showon property 
             **/
            remarks: function () {
                return this.Order.remarks.filter(a => a.showOn == ShowOn.Both || a.showOn == ShowOn.KitchenPlanning);
            },

            accentClass: function () {
                var className = {};
                className['accent' + this.Order.status] = 1;              
                return className;
            },

            orderWidth: function () {
                return timeStore.calculateWidth(this.Order.totalTime);
            }
            ,

            timstoreStartTime: function () {
                return timeStore.state.startTime;
            },

            products: function () {
                return this.Order.products.slice().sort((a, b) => {
                    return this.getProductStartTime(a) - this.getProductStartTime(b);
                });
            }

            //planning: function () {
            //	return this.Order.planning == 1 ? "Geplanned" : "Zo snel mogelijk";
            //}
        },

        watch: {

            //"Order.createDate": function () { //newValue, oldValue
            //	var _this = this;
            //	_this.createX = timeStore.calculateXPosition(_this.Order.createDate);
            //},

            "Order.calculatedReadyDate": function () { //newValue, oldValue
                var _this = this;

                if (_this.Order.calculatedReadyDate) {
                    _this.startX = timeStore.calculateXPosition(_this.Order.startDate);
                } else {
                    this.startX = 0;
                }

            },

            "Order.startDate": function () {
                var _this = this;

                if (_this.Order.startDate) {
                    _this.endX = timeStore.calculateXPosition(_this.Order.calculatedReadyDate);
                } else {
                    this.endX = 0;
                }
            },

            "timstoreStartTime": function () {
                var _this = this;

                if (_this.Order.calculatedReadyDate) {
                    _this.startX = timeStore.calculateXPosition(_this.Order.startDate);
                } else {
                    this.startX = 0;
                }

            },

            /*
            "Order.status": function (newvalue, oldvalue) {
                if (newvalue == 3) {
                    this.showOrderInAlert("De order kan worden ingepakt");
                }
            }*/

        },

        mounted: function () {

            //var _this = this;

            //this.$el.querySelectorAll && this.$el.querySelectorAll(".line, .ruler").forEach(function (el) {
            //	el.style.left = _this.Left + 'px';
            //});

            //// todo: use draggable here and in the timeline.
            //var draggable = new Draggable(_this.$el, {
            //	'draggable': '.time-block',

            //	mirror: {
            //		constrainDimensions: true,
            //		//cursorOffsetX: 10,
            //		//cursorOffsetY: 10,
            //		yAxis: false
            //	}

            //});
            //var newX, start;

            //draggable.on('drag:start', e => {
            //	start = e.sensorEvent.clientX;
            //	console.log(start);
            //});

            //draggable.on('drag:move', e => {
            //	var end = e.sensorEvent.clientX;
            //	newX = end;
            //	console.log(e.mirror);
            //});

            //draggable.on('drag:stop', (a, b) => {
            //	var moved = start - newX;// a.source.offsetLeft;

            //	// newx= px, calculate percentage (position is based on percentage)
            //	var width = this.$el.querySelector('.line').offsetWidth;
            //	var percentage = (moved / width) *100

            //	let startDate = _this.StartDate.getTime();
            //	let endDate = _this.EndDate.getTime();
            //	let TotalMiliseconds = endDate - startDate;

            //	let newdate = startDate + (percentage / 100) * TotalMiliseconds;
            //	var date = new Date(newdate);

            //	this.$signalR.setStartDate(_this.Order, date);

            //});




            // todo : combine this logic with drag-drop in timeline.vue
            // this.createX = timeStore.calculateXPosition(_this.Order.createDate);

            if (this.Order.calculatedReadyDate)
                this.startX = timeStore.calculateXPosition(this.Order.startDate);

            if (this.Order.startDate)
                this.endX = timeStore.calculateXPosition(this.Order.calculatedReadyDate);

            /*
            function onMouseDown(e) {

                var start = e.clientX || e.touches[0].clientX;

                var width = _this.$el.querySelector('.line').offsetWidth;


                if (e.touches) {
                    document.body.ontouchmove = function (e) {

                        var end = e.touches[0].clientX;
                        _this.xPosition += (end - start) / width * 100;
                        start = end;
                    };

                    document.body.ontouchend = function () {
                        document.body.ontouchmove = document.body.ontouchend = null;
                        onDragEnd();
                    };
                }
                else {
                    document.body.onmousemove = function (e) {
                        var end = e.clientX;
                        _this.xPosition += (end - start) / width * 100;
                        start = end;
                    };
                    document.body.onmouseup = function () {
                        document.body.onmousemove = document.body.onmouseup = null;
                        onDragEnd();
                    };
                }

                function onDragEnd() {
                    // calculate position to time

                    let startDate = timeStore.state.startTime.getTime();
                    let TotalMiliseconds = timeStore.state.totalMilliseconds;
                    let newdate = startDate + (_this.xPosition / 100) * TotalMiliseconds;
                    var date = new Date(newdate);

                    this.$signalR.setStartDate(_this.Order, date);
                }


                e.stopPropagation();
            }

            this.$el.querySelector('.time-block').onmousedown = onMouseDown;
            this.$el.querySelector('.time-block').ontouchstart = onMouseDown;
            */
        }


    };

    export { Order as default };

</script>
